import { render, staticRenderFns } from "./PidBatchesTable.vue?vue&type=template&id=cccc09c0&scoped=true&"
import script from "./PidBatchesTable.vue?vue&type=script&lang=js&"
export * from "./PidBatchesTable.vue?vue&type=script&lang=js&"
import style0 from "./PidBatchesTable.vue?vue&type=style&index=0&id=cccc09c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccc09c0",
  null
  
)

export default component.exports